module.exports = __webpack_public_path__ + "static/media/FieldTrip.f733ce5d.png";